import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';
import ErrorMessage from '../../shared/ErrorMessage.js';
import DateInput from '../../shared/inputs/DateInput.js';
import { compareWeighins, formatWeighDay } from '../weighins.js';
import '../lots/WeightLots.css';

const WeightAnimalWeighins = () => {
  const { tag }    = useParams();
  const { t }      = useTranslation();
  const today      = new Date().toISOString().split('T')[0];
  const [weights,      setWeights]      = useState([]);
  const [newWeight,    setNewWeight]    = useState('');
  const [newDate,      setNewDate]      = useState(today);
  const [errorMessage, setErrorMessage] = useState('');

  const loadWeights = () => {
    Fetch(`api/data/weights?search_fields=tag&search_values=${tag}`, 'get', null,
      (data) => setWeights((data || []).filter(w => w.date).sort(compareWeighins))
    );
  };

  useEffect(() => { loadWeights(); }, [tag]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage('');
    if (!newWeight || parseFloat(newWeight) <= 0) return;
    // lot_id 0: the API keeps the animal in its current weight lot, or
    // enrolls it in the default lot if it isn't in one yet.
    Fetch('api/weight/entry', 'post',
      JSON.stringify({ tag: tag, date: newDate, weight: parseFloat(newWeight), lot_id: 0 }),
      () => { setNewWeight(''); setNewDate(today); loadWeights(); },
      () => setErrorMessage(t('error_saving'))
    );
  };

  return (
    <div className="wld-page">
      <div className="wld-subpage-title">{t('tag')} #{tag} — {t('total_weigh_ins')}</div>

      {weights.length === 0 ? (
        <div className="wl-empty-note">{t('no_weigh_ins')}</div>
      ) : (
        <div className="wl-sessions-list">
          {weights.map((w, i) => (
            <div key={i} className="wl-session-row">
              <span className="wl-session-date">{formatWeighDay(w)}</span>
              <span className="wl-session-weight">{w.weight} kg</span>
            </div>
          ))}
        </div>
      )}

      <form className="wl-inline-form" onSubmit={handleSubmit}>
        <input type="number" value={newWeight} onChange={e => setNewWeight(e.target.value)}
          placeholder={t('unit_kg')} min="1" max="9999" step="0.1" required />
        <DateInput value={newDate} onChange={(v) => setNewDate(v)} required />
        <button type="submit" className="wl-inline-btn">+</button>
      </form>
      <ErrorMessage message={errorMessage} />
    </div>
  );
};

export default WeightAnimalWeighins;
